import React from "react";
import Link from "next/link";
import SectionTitle from "../common/section_title";
import { getAssets } from "@unisearch/helpers";
import styles from "./styles/why_choose_home.module.scss";

export const WhyChooseHome = () => {
  return (
    <section className={styles.section_why_choose}>
      {/* <div className={styles.background_color}></div> */}
      <div className="container">
        <SectionTitle
          // shadow_text="YOUR GUIDANCE TO CONNECT WITH MENTORS"
          title="Why Choose UniSearch?"
        >
          <p>
            UniSearch combines the expert knowledge of our counsellors, our
            strong relations with universities around the world, a decade of
            study abroad expertise with international students, and cutting-edge
            smart technology to simplify every step of studying abroad into a
            linear process.
          </p>
        </SectionTitle>

        <div className={styles.choose_wrapper}>
          <div className={`${styles.choose_box_wrapper} ${styles.student}`}>
            <div className={styles.choose_box_head}>
              <h4 className={styles.title}>Student</h4>
              <p className={styles.desc}>
                From shortlisting and applying to the right programs and
                universities through AI-driven profile-matching, to getting visa
                application assistance, finding accommodation and more, we
                combine technological and interpersonal support to make studying
                abroad smooth sailing
              </p>
            </div>
            <div className={styles.image_wrapper}>
              <img src={getAssets("assets/images/student.png")} alt="student" />
            </div>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/student">
                <a>Student</a>
              </Link>
            </div>
          </div>
          <div className={`${styles.choose_box_wrapper} ${styles.university}`}>
            <div className={styles.choose_box_head}>
              <h4 className={styles.title}>University</h4>
              <p className={styles.desc}>
                With our in-depth market insight of emerging source markets, and
                the smart technology powering UniSearch, we connect you to the
                most promising students for your university from around the
                world, turning diverse best-fit prospects into successful
                applicants
              </p>
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/university.png")}
                alt="university"
              />
            </div>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university">
                <a>University</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseHome;
